<template>
  <v-card
    outlined
    class="upload-box"
    :style="{
      width: declaration ? '120px' : '170px',
      height: declaration ? '120px' : '170px',
    }"
    @click="triggerUpload"
  >
    <v-card-text class="pa-1">
      <img
        v-if="preview"
        :src="preview"
        alt="Profile Photo"
        class="uploaded-image"
      />
      <div v-else class="upload-instructions">
        <v-icon size="48" class="mb-2">mdi-camera</v-icon>
        <p class="mb-0">Upload Photo *</p>
        <p class="caption mb-0">
          Please select a file with *.png, *.jpeg, or *.jpg extension.
        </p>
      </div>
    </v-card-text>
    <attachmentViewer
      v-if="dialog"
      @closeDialog="dialog = false"
      :value="dialogData"
    />
  </v-card>
</template>

<script>
import attachmentViewer from "@/components/attachmentViewer.vue";

export default {
  components: { attachmentViewer },
  props: {
    photo: {
      type: Object,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    declaration: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      preview: null, // Stores preview of uploaded image
      dialog: false,
      dialogData: {},
    };
  },
  computed: {},
  watch: {
    photo: {
      handler(newVal) {
        this.preview = Object.keys(newVal).length
          ? `data:image/png;base64,${newVal.file_binary}`
          : null;
      },
    },
  },

  created() {
    this.preview = Object.keys(this.photo).length
      ? `data:image/png;base64,${this.photo.file_binary}`
      : null;
  },
  methods: {
    triggerUpload() {
      this.dialogData = Object.keys(this.photo).length
        ? { type: "image", file_binary: this.photo.file_binary }
        : {};
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.upload-box {
  border: 1px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
}

.upload-box:hover {
  border-color: #777;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-instructions {
  text-align: center;
}

.upload-instructions .caption {
  color: #666;
  font-size: 0.75rem;
}
</style>
